<template>
  <div class="pcr-establishment-tree">
    <el-input placeholder="Filter keyword" v-model="filterText" id="tree-search-input"></el-input><el-button @click="collapseAll" id="tree-collapse-button">
      <i class="fa fa-times" aria-hidden="true"></i>
    </el-button>
    <div class="loader-container" v-show="refreshing">
      <ring-loader></ring-loader>
    </div>
    <el-tree
      v-show="!refreshing"
      :accordion="true"
      class="filter-tree"
      node-key="TreeUniqueId"
      :expand-on-click-node="false"
      :default-expanded-keys="defaultExpandedKeys"
      :current-node-key="currentNodeKey"
      :render-content="renderContent"
      :data="tree"
      :props="defaultProps"
      auto-expand-parent
      highlight-current
      @current-change="changeCurrent"
      :filter-node-method="filterNode"
      ref="tree"
    ></el-tree>
  </div>
</template>

<script>
import Vue from "vue";

Vue.prototype.$currentTreeNode = {
  Id: 0,
  Label: "",
  ParentId: 0,
  TreeUniqueId: 0,
  Type: "",
  Children: []
};

export default Vue.component("pcr-establishment-tree", {
  data() {
    return {
      refreshing: false,
      tree: [],
      current: {
        Id: 0,
        Label: "",
        ParentId: 0,
        TreeUniqueId: 0,
        Type: "",
        Children: []
      },
      filterText: "",
      defaultProps: {
        children: "Children",
        label: "Label",
        id: "Id"
      },
      _defaultExpandedKeys: []
    };
  },
  computed: {
    currentNodeKey() {
      return this.current ? this.current.TreeUniqueId : 0;
    },
    defaultExpandedKeys() {
      this.$data._defaultExpandedKeys.length = 0;
      if (this.current) {
        this.$data._defaultExpandedKeys.push(this.current.TreeUniqueId);
      }
      return this.$data._defaultExpandedKeys;
    }
  },

  mounted: function() {
    this.refresh();

    this.$router.afterEach(() => this.selectCurrentFromQueryString());

    this.$root.$on("pcr_update_tree", () => {
      this.refresh();
    });
  },
  methods: {
    refresh() {
      if (!this.refreshing) {
        this.refreshing = true;

        this.$http.get("/api/establishment/tree").then(response => {
          this.tree = response.data;

          this.selectCurrentFromQueryString();
          this.refreshing = false;
        }, () => this.refreshing = false);
      }
    },

    filterNode(value, data, node) {
      if (!value) return true;
      return data.Label.toLowerCase().indexOf(value.toLowerCase()) !== -1;
    },

    collapseAll() {
      Object.keys(this.$refs.tree.store.nodesMap).map((key, index) => {
        this.$refs.tree.store.nodesMap[key].expanded = false;
      });
    },

    changeCurrent(node) {
      this.current = node;

      let query = _.cloneDeep(this.$router.currentRoute.query);

      query.establishmentId = node.Id;
      query.userId = undefined;
      query.SQLAdmin = undefined;

      this.$router.push({ query: query });

      this.$emit("change-current", this.current);
    },

    selectCurrentFromQueryString() {
      var userId = this.$router.currentRoute.query.userId;
      var establishmentId = this.$router.currentRoute.query.establishmentId;

      if (userId) {
        // this.current = this.findDeepInTree(this.tree, (x) => x.ParentId == establishmentId && x.Id == userId && x.Type == 'User');

        this.current = this.findDeepInTree(
          this.tree,
          x => x.Id == establishmentId
        );
        this.$emit("change-current", {
          Id: userId,
          ParentId: establishmentId,
          Type: "User",
          Rights: establishmentId ? this.current.Rights : 127
        });
        return;
      } else if (establishmentId) {
        this.current = this.findDeepInTree(
          this.tree,
          x => x.Id == establishmentId
        );
        this.$emit("change-current", this.current);
        return;
      }

      //auto select the first node, if current is set by default
      this.current = this.tree[0];
      this.$emit("change-current", this.current);
    },

    findDeepInTree(tree, predicate) {
      var result = _.find(tree, predicate);

      if (result) return result;

      var children = _.flatten(_.map(tree, x => x.Children));

      if (!children || !children.length) return null;

      result = this.findDeepInTree(children, predicate);

      return result;
    },

    renderContent(h, { node, data, store }) {
      const props = {
        item: data.Rights
      };

      if (data.Type === "Partner") {
        return (
          <div class="pcr-node partner">
            <i
              class="fa fa-building"
              aria-hidden="true"
              style="margin-right: 4px;"
            />
            <b class="tree-label partner">{node.label}</b>
            <div class="tree-grant">
              <pcr-grant-level-label {...{ props }} />
            </div>
          </div>
        );
      }
      if (data.Type === "Managing") {
        return (
          <div class="pcr-node managing">
            <i
              class="fa fa-building"
              aria-hidden="true"
              style="margin-right: 4px;"
            />
            <span class="tree-label managing">{node.label}</span>
            <div class="tree-grant">
              <pcr-grant-level-label {...{ props }} />
            </div>
          </div>
        );
      }
      if (data.Type === "Establishment") {
        return (
          <div class="pcr-node establishment">
            <i
              class="fa fa-home"
              aria-hidden="true"
              style="margin-right: 4px;"
            />
            <span class="tree-label establishment">{node.label}</span>
            <div class="tree-grant">
              <pcr-grant-level-label {...{ props }} />
            </div>
          </div>
        );
      }
      if (data.Type === "Group") {
        return (
          <div class="pcr-node group">
            <i
              class="fa fa-users"
              aria-hidden="true"
              style="margin-right: 4px;"
            />
            <span class="tree-label group">{node.label}</span>
            <div class="tree-grant">
              <pcr-grant-level-label {...{ props }} />
            </div>
          </div>
        );
      }
    }
  },

  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
    current(val) {
      //updated global variable
      Vue.prototype.$currentTreeNode = this.current;

      if (val) {
        setTimeout(() => {
          var scrollTo = $(".el-tree-node.is-current");
          var container = $(".el-tree");

          function isScrolledIntoView(elem) {
            var $elem = $(elem);
            var $window = $(window);

            var docViewTop = $window.scrollTop();
            var docViewBottom = docViewTop + $window.height();

            var elemTop = $elem.offset().top;
            var elemBottom = elemTop + $elem.height();

            return elemBottom <= docViewBottom && elemTop >= docViewTop;
          }

          if (!isScrolledIntoView(scrollTo)) {
            container.animate({
              scrollTop:
                scrollTo.offset().top -
                container.offset().top +
                container.scrollTop()
            });
          }
        });
      }
    }
  }
});
</script>

<style lang="scss">
.loader-container {
  height: 100%;
  background-color: #fff;
  border-bottom: 1px solid #d1dbe5;

  .v-spinner {
    height: 100%;
    .v-ring1 {
      top: calc( 50% - 60px );
      margin: auto;
    }
  }
}

#tree-search-input {
  width: calc(100% - 43px);
}
#tree-search-input input.el-input__inner {
  border-radius: 0px;
}
#tree-collapse-button {
  margin: 0;
  border-radius: 0px;
}
.el-tree-node {
  white-space: initial;
}
</style>



// WEBPACK FOOTER //
// src/components/visual/pcr-establishment-tree.vue